import Vue from 'vue'
import App from './App.vue'
import store from './store';
import VueRouter from 'vue-router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueScrollTo from 'vue-scrollto'
import '@/assets/style/main.scss';

//import main from '@/components/main.vue'
import wisher from '@/components/wisher.vue'

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(VueAwesomeSwiper)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
const router = new VueRouter({
  mode: 'history',
  base: 'wish/',
  routes: [ 
    {
      path: '/:id',
      component: wisher,
    },
    {
      path: '/',
      redirect: '/sustainability_23',
    },
    {
      path: '*',
      redirect: '/sustainability_23'
    },
  ]
})

// router.afterEach(( to) => {
//   console.log(to.path)

// });

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
